<template>
  <div class="kk-teams">
    <nav-header :title="$t('sidebar.teams')" :is-loading="isLoading"></nav-header>
    <!-- Body -->
    <div class="kk-teams__tree" @click="click" @contextmenu="rightClick">
      <tree v-if="Object.keys(teamsHashTable).length > 0" :data="teams" :depth="0" />
    </div>
    <nav-footer :items="footerItems" :trash-disabled="true"></nav-footer>
    <add-member-dialog />
  </div>
</template>

<script>
import hotkeys from "hotkeys-js";
import Tree from "./Tree.vue";
import { Direction, HotkeyScopes, TreeDefaultNodeIds } from "../../../../utils/constants";
import { TeamTypes } from "../../../../utils/icons";
import AddMemberDialog from "./AddMemberDialog.vue";
import NavHeader from "../RedZoneHeader.vue";
import NavFooter from "../RedZoneFooter.vue";

const getItemId = (e) => {
  const node = e.target.closest(".kk-tree__title");
  if (!node) return;
  return node.dataset.id;
};

export default {
  components: { Tree, AddMemberDialog, NavHeader, NavFooter },

  computed: {
    teamsHashTable() {
      return this.$store.state.teams.teamsHashTable;
    },
    footerItems() {
      return [
        {
          id: 1,
          title: this.$t("sidebar.newTeam"),
          icon: "icon-plus-circle",
          func: this.addTeam,
          testId: "footer-new-teams-icon",
        },
      ];
    },
    teams() {
      const tree = this.$store.state.teams.tree?.activeSubTree;
      if (!tree) return [];

      // Do not show ROOT element
      if (tree.id === TreeDefaultNodeIds.Root) {
        return tree.children;
      }
      return [tree];
    },
    activeSidebarItem() {
      return this.$store.state.teams.activeItem;
    },
    isLoading() {
      return this.$store.state.teams.isLoading;
    },
    clickedKeys() {
      return this.$store.state.clickedKeys;
    },
  },
  mounted() {
    hotkeys("up,down,Space,right,left,m", HotkeyScopes.Sidebar.Teams, (event, handler) => {
      event.preventDefault();

      switch (handler.key) {
        case "Space":
          return this.$store.dispatch("teams/toggleExpanded", { id: this.activeSidebarItem.id });
        case "right":
          return this.$store.dispatch("teams/toggleExpanded", { id: this.activeSidebarItem.id, expanded: true });
        case "left":
          return this.$store.dispatch("teams/toggleExpanded", { id: this.activeSidebarItem.id, expanded: false });
        case "m":
          return this.$store.dispatch("teams/sendMail", { id: this.activeSidebarItem.id });
      }
    });
    document.addEventListener("keypress", this.keypress);
  },
  beforeUnmount() {
    hotkeys.unbind("up,down,Space,right,left,m", HotkeyScopes.Sidebar.Teams);
    document.removeEventListener("keypress", this.keypress);
  },
  methods: {
    click(e) {
      const id = getItemId(e);
      if (!id) return;

      this.$store.dispatch("teams/toggleExpanded", { id });
      this.$store.dispatch("setScope", HotkeyScopes.Sidebar.Teams);
    },
    rightClick(e) {
      const id = getItemId(e);
      if (!id) return;

      e.preventDefault();
      if (e.button == -1) return; // ignore shift+f10 key press.
      this.$store.dispatch("teams/setActiveItem", { id });
      this.$store.dispatch("setActiveContextMenu", { id, x: e.x, y: e.y });
    },
    addTeam() {
      this.$store.dispatch("teams/addTeam");
    },
    keypress(event) {
      // must listen to keypress because of different keyboard layouts
      const scope = hotkeys.getScope();
      if (scope !== HotkeyScopes.Sidebar.Teams) return;

      const charCode = event.charCode || event.keyCode || event.which;
      var character = String.fromCharCode(charCode);
      if (!this.activeSidebarItem.id) return;

      const sidebarItem = this.$store.getters["teams/getItemById"](this.activeSidebarItem.id);

      switch (character) {
        case "/":
          event.preventDefault();
          if (sidebarItem.type === TeamTypes.Team)
            return this.$store.dispatch("teams/setActiveItem", { id: this.activeSidebarItem.id, editMode: true });
          return this.$store.dispatch("teams/setAddMemberDialog", {
            id: this.activeSidebarItem.id,
            show: true,
            editMode: true,
          });
        case "-":
          event.preventDefault();
          if (sidebarItem.type === TeamTypes.Team) return;

          return this.$store.dispatch("panel/setDeleteDialog", {
            show: true,
            ids: this.activeSidebarItem.id,
            title: this.$t("sidebar.delete.team.title"),
            description: this.$t("sidebar.delete.team.description"),
            itemType: "teams",
            action: () => {
              this.$store.dispatch(`teams/remove`, { ids: [this.activeSidebarItem.id] });
            },
          });
        case "+":
          if (sidebarItem.type !== TeamTypes.Team) return;
          event.preventDefault();
          return this.$store.dispatch("teams/setAddMemberDialog", {
            id: this.activeSidebarItem.id,
            show: true,
          });
      }
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../../../assets/styles/variables";
.kk-teams {
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
  &__tree {
    padding-top: 0.4rem;
    flex: 1;
    overflow-y: auto;
    overflow-x: hidden;
  }
}
</style>
